import { action, makeObservable, observable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';

export class GroupsDashboardController {
  rootStore: RootStore;
  showAssignAgentsModal = false;

  async uploadGroupToGroupStore(groupId: string, agencyId?: string): Promise<void> {
    this.rootStore.assignAgentsModalStore.setLoading(true);
    await this.rootStore.groupStore.getGroupById(groupId);
    await this.rootStore.agentsStore.requestAgentsAndAssignees(agencyId);
    runInAction(() => {
      this.rootStore.assignAgentsModalStore.setLoading(false);
    });
  }

  openAssignAgentsModal(): void {
    this.showAssignAgentsModal = true;
  }

  closeAssignAgentsModal(): void {
    this.showAssignAgentsModal = false;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      showAssignAgentsModal: observable,
      uploadGroupToGroupStore: action.bound,
      openAssignAgentsModal: action.bound,
      closeAssignAgentsModal: action.bound,
    });
  }
}
